/**
 * Demo track (F08 FR5) — a real example workload, reviewed and run on GitHub.
 *
 * "Try this example" no longer submits an in-console job. The example is a real,
 * billable workload, so running it from the console would charge the user's
 * account on a single click. Instead the gated affordance opens the public
 * omega-demo repository in a new tab, where the user can read the code and run
 * it themselves on their own terms (still real, billable compute when they do).
 *
 * `DEMO_JOB` stays exported because it documents the canonical example payload /
 * omega-demo image (the pinned tag, the standard-class shape) that the repo runs;
 * it is kept in sync with the published workload even though the console no longer
 * pre-fills it.
 */

export const DEMO_REPO_URL = "https://github.com/Omega-AI-HPC/omega-demo";

export const DEMO_JOB = {
  service_class: "standard",
  // A valid workload name so the onboarding/Guide prefill satisfies the
  // Console-required job-identity field (jobValidation: 1..100 chars).
  workload_name: "example-workload",
  compute_required: 10,
  memory_required: 4,
  // The authoritative example workload (omega-demo): a small, deterministic,
  // GPU-free numpy job published at a pinned tag (never :latest). See the
  // omega-demo submodule and docs/FRONTEND.md for the image/bump procedure.
  container_image: "ghcr.io/omega-ai-hpc/omega-demo:v0.1.0",
  command: ["python", "main.py"],
  gpu_count: 0,
  inputSource: "none",
};

export const demoTrack = {
  id: "runnable-demo",
  title: "Try a runnable example",
  track: "demo",
  order: 1,
  steps: [
    {
      id: "demo-try",
      title: "Try this example",
      body: [
        "This is a real example workload (omega-demo): a small, deterministic, GPU-free numerical job. Running it uses real, billable compute, so the console does not submit it for you.",
        "Click **Try this example** to open the omega-demo repository on GitHub in a new tab. There you can review the code, see exactly what it does, and run it yourself when you are ready.",
        "When you do run it, it goes through the same flow as any job you build: submit it, watch it in **Jobs**, then open the job to read its decision and fetch its output.",
      ].join("\n\n"),
      externalUrl: { label: "Try this example", url: DEMO_REPO_URL },
    },
  ],
};
